import { css } from 'styled-components';

const smartTextStyles = css`
  color: ${props => (props.color ? props.color : '#333')};
  font-size: ${props => (props.fontSize ? props.fontSize : '18px')};
  font-family: ${props => {
    const defaultFamily = 'Lato, DefaultLato, "sans-serif"';
    const fontFamily = `${props.fontFamily}, Default${props.fontFamily}, "sans-serif"`;
    return props.fontFamily ? fontFamily : defaultFamily;
  }};

  &:hover {
    color: ${props => {
      const color = props.color ? props.color : '#333';
      return props.hoverColor ? props.hoverColor : color;
    }};
  }
`;

export default smartTextStyles;
